module.exports = __webpack_public_path__ + "img/usa-cerebrovascular-disease-female.97409c1e.png";